var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlobSceneHaikei16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900 0H0V600H900V0Z",
    fill: "#9191E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 420C864.1 424.4 828.2 428.7 783.5 434.7C738.8 440.6 685.4 448.2 656.6 421.5C627.9 394.9 623.9 334 604.4 295.6C585 257.2 550.1 241.2 531.1 213C512 184.8 508.8 144.2 502 106.6C495.3 69.1 485.2 34.5 475 0H900V420Z",
    fill: "#141A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 221C31.3 218 62.6 215.1 106.4 203C150.1 190.9 206.3 169.7 238.5 186.9C270.7 204.1 278.8 259.8 309 291C339.2 322.2 391.5 328.9 421.5 356.6C451.6 384.3 459.4 433 458.8 477.1C458.2 521.1 449.1 560.6 440 600H0V221Z",
    fill: "#141A8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobSceneHaikei16);
export default __webpack_public_path__ + "static/media/blob-scene-haikei-16.67bf14b91b59128670337867ebc20595.svg";
export { ForwardRef as ReactComponent };